import { render, staticRenderFns } from "./CrmIcon.vue?vue&type=template&id=7a387396&"
import script from "./CrmIcon.vue?vue&type=script&lang=ts&"
export * from "./CrmIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports